import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCavp = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>
         {context.state['Carriere'+ClientConjoint].filter((Carriere) => Carriere.Nature === "Cavp" ).length > 0 && (
        <tr>
          <td>CAVP</td>
          <td>
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].TrimestreCompCavp}
              onChange={(e)=>{context.handlePointRetraite(ClientConjoint,"TrimestreCompCavp",e)}}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
          <td>
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCavpComp}
              onChange={(e)=>{
                context.handlePointRetraite(ClientConjoint,"AnneeFinCavpComp",e)
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              small
            />
          </td>
          <td>
            <TextField
              value={resultRetraite?.InfosRetraite?.Cavp?.General?.RepartCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Cavp?.General?.RepartCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
        </tr>
      )}
    </>
  );
};
export default PointCavp;
